import { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import type { DbPortalVertraulichkeit } from '@gql/shared-types';
import { api } from '../api/client.js';
import { useAuth } from '../auth/AuthKontext.js';

export function Vertraulichkeit() {
  const { zustand, neuLaden, abmelden } = useAuth();
  const navigate = useNavigate();
  const [text, setText] = useState<DbPortalVertraulichkeit | null>(null);
  const [zugestimmt, setZugestimmt] = useState(false);
  const [fehler, setFehler] = useState<string | null>(null);
  const [sendet, setSendet] = useState(false);

  useEffect(() => {
    api<DbPortalVertraulichkeit>('/vertraulichkeit')
      .then(setText)
      .catch((f: Error) => setFehler(f.message));
  }, []);

  if (zustand.status === 'bereit' && zustand.ich.nutzer && !zustand.ich.nutzer.ndaErforderlich) {
    return <Navigate to="/standorte" replace />;
  }

  async function bestaetigen() {
    if (!text) return;
    setSendet(true);
    setFehler(null);
    try {
      await api('/vertraulichkeit', { methode: 'POST', json: { version: text.version, hash: text.hash, zugestimmt: true } });
      await neuLaden();
      navigate('/standorte', { replace: true });
    } catch (f) {
      setFehler((f as Error).message);
    } finally {
      setSendet(false);
    }
  }

  return (
    <article className="seite seite-mittel">
      <h1>{text?.titel ?? 'Vertraulichkeitsvereinbarung'}</h1>
      {text?.platzhalter && (
        <p className="warnkasten" role="note">
          Entwurf: Der verbindliche Text liegt noch nicht vor. Im Produktivbetrieb kann dieser Entwurf nicht bestätigt werden.
        </p>
      )}
      {!text && !fehler && (
        <p role="status">
          <span className="spinner" aria-hidden="true" /> Text wird geladen …
        </p>
      )}
      {text && (
        <div className="vertragstext">
          {text.text.split(/\n{2,}/).map((absatz, i) => (
            <p key={i}>{absatz}</p>
          ))}
          <p className="hinweis-klein">Fassung {text.version}</p>
        </div>
      )}
      {fehler && (
        <p className="fehlertext" role="alert">
          {fehler}
        </p>
      )}
      {text && (
        <div className="zustimmung">
          <label className="checkbox-zeile">
            <input type="checkbox" checked={zugestimmt} onChange={(e) => setZugestimmt(e.target.checked)} />
            <span>Ich habe die Vereinbarung gelesen und stimme ihr zu.</span>
          </label>
          <div className="knopfreihe">
            <button type="button" className="knopf" disabled={!zugestimmt || sendet} onClick={() => void bestaetigen()}>
              {sendet ? 'Wird gespeichert …' : 'Zustimmen und fortfahren'}
            </button>
            <button type="button" className="knopf-sekundaer knopf-auto" onClick={() => void abmelden()}>
              Abbrechen und abmelden
            </button>
          </div>
        </div>
      )}
    </article>
  );
}
